import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();

  const { loginType, email, phoneNumber } = location.state || {};
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const carid =null

  const API_BASE = "http://192.168.29.147:5000/api/auth/user";

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = {
        otp,
        ...(loginType === "email" ? { email } : { phoneNumber }),
      };

      const response = await axios.post(`${API_BASE}/verify`, data);
      console.log(response);

      if (response.status === 200) {
        const token = response.data.data.token;
        localStorage.setItem("userToken", token);
        if (!carid) {
          navigate("/booking/carlisting");
        } else {
          navigate("/booking/add", { replace: true });
        }
      }
    } catch (err) {
      console.error("OTP Verification error:", err);
      if (err.response) {
        setError(err.response.data.message || "OTP verification failed.");
      } else if (err.request) {
        setError("Network error. Please check your connection.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-amber-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8 border border-amber-100">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-12 h-12 mx-auto bg-amber-500 rounded-full flex items-center justify-center text-white text-2xl">
            🔐
          </div>
          <h2 className="text-2xl font-bold text-amber-600 mt-4">Verify OTP</h2>
          <p className="text-sm text-gray-600 mt-1">
            Enter the OTP sent to your{" "}
            <span className="font-semibold text-amber-700">
              {loginType === "email" ? email : phoneNumber}
            </span>
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleVerify} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              OTP Code
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter 6-digit OTP"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:outline-none transition"
              required
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-300 text-red-700 text-sm p-3 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-600 text-white py-3 rounded-lg font-semibold transition duration-200 shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" />
            ) : (
              "Verify OTP"
            )}
          </button>
        </form>

        {/* Back to login */}
        <div className="mt-6 text-center">
          <button
            onClick={() => navigate("/user-login")}
            className="text-amber-600 hover:text-amber-700 text-sm font-medium underline underline-offset-4 transition-all"
          >
            ← Back to Login Page
          </button>
        </div>
      </div>
    </div>
  );
}
